import { useAppSelector } from 'store/hooks';
import { selectPrivateGroupChat } from 'features/chat/chatSlice';
import { PermissionTypes } from 'features/permissions/types';
import { selectLocalUserRole } from 'features/users/usersSlice';
import { usePermissions } from 'features/permissions/usePermissions';
import { useFeatureFlag } from 'features/feature-set/useFeatureFlag';
import { selectIsBreakoutRoom } from 'features/breakout-rooms/breakoutRoomsSlice';
import { canAccessChat } from 'features/chat/canAccessChat';
import { useSystemSession } from 'hooks/useSystemSession';

export const useChat = () => {
  const { hasPermissions } = usePermissions();
  const isSystemSession = useSystemSession();

  const generalChatEnabled = useFeatureFlag('generalChat');
  const privateChatEnabled = useFeatureFlag('privateChat');
  const privateGroupChatEnabled = useFeatureFlag('privateGroupChat');

  const privateGroupChat = useAppSelector(selectPrivateGroupChat);
  const localRole = useAppSelector(selectLocalUserRole);
  const isBreakoutRoom = useAppSelector(selectIsBreakoutRoom);

  const access = canAccessChat({
    generalChatEnabled,
    canChatInGeneral: hasPermissions(PermissionTypes.generalChat),
    privateChatEnabled,
    canChatInPrivate: hasPermissions(PermissionTypes.privateChat),
    privateGroupChatEnabled,
    privateGroupChatRoles: privateGroupChat.roles,
    localUserRole: localRole,
    isBreakoutRoom,
    isSystemSession,
  });

  return {
    ...access,
    privateGroupChat,
    readOnly: isSystemSession,
  };
};
